import VerticalVideosPage from './VerticaVideosPage'

export default VerticalVideosPage
// eslint-disable-next-line import/export
export * from './VerticaVideosPage'
